import { Issue } from '../../remote';
import { TableDataCell } from 'sdi/components/table2';
import { getOsmResourceId } from 'qa/src/queries/qa';

export const renderOsmIdCell = (issue: Issue): TableDataCell =>
    getOsmResourceId(issue).fold<TableDataCell>(
        '',
        (
            { id, type } //TODO
        ) =>
            //({
            //     node: A(
            //         {
            //             href: `https://www.openstreetmap.org/${type}/${id}/`,
            //             target: '_blank',
            //         },
            //         id
            //     ),
            //     string: id.toString(),
            // }));
            `${type}-${id}`
    );
